import { useTranslation } from 'react-i18next';

export default function LatestBooksTitle() {
    const { i18n } = useTranslation();

    return (
        <>
            {i18n.language === "ar" ? (
                <div className="d-flex justify-content-between  flex-column">
                    <h3>أحدث الكتب</h3>
                    <p>التي لدينا في منصة الكتب … قم بزيارة منصة الكتب </p>
                </div>
            ) : (
                <div className="d-flex justify-content-between  flex-column">
                    <h3>Latest Books</h3>
                    <p>That we have on the Library … Visit the books platform</p>
                </div>
            )}
        </>
    )
}

